export type PhoneValidationData = {
    phone: string
    IdCliente: string
    Codigo: string
}

export enum ModeloEnvio {
    SMS = '0',
    WHATSAPP = '1',
}
export type EnviarArpCodigoRequest = {
    subscriberId: string
    modeloEnvio: ModeloEnvio
    RecaptchaToken: string
    EReenvio: boolean
}